"use client";

import { cn } from "@repo/design-system/utils/cn";
import Image, { type ImageProps } from "next/image";
import { useRef } from "react";

export interface CustomImageProps extends Omit<ImageProps, "alt"> {
  alt?: string;
  blur?: boolean;
  isLocalPath?: boolean;
  src: string;
}

export function CustomImage({
  src,
  alt = "",
  isLocalPath = false,
  fill,
  blur = false,
  className,
  ...rest
}: CustomImageProps) {
  const imgRef = useRef<HTMLImageElement>(null);
  if (!src) {
    return null;
  }
  const isAbsolute = src.startsWith("http://") || src.startsWith("https://");
  const needsNoPrefix =
    isLocalPath || src.startsWith("/clients/") || isAbsolute;

  const finalSrc = needsNoPrefix
    ? src
    : `${process.env.NEXT_PUBLIC_ASSET_URL}${src}`;

  return (
    <Image
      {...rest}
      alt={alt}
      className={cn(
        blur && "blur-sm transition-[filter] duration-500 ease-out",
        className
      )}
      fill={fill}
      onLoad={
        blur
          ? () => imgRef.current?.classList.replace("blur-sm", "blur-0")
          : undefined
      }
      ref={imgRef}
      src={finalSrc}
    />
  );
}
